import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';

import { Address, NewAddress, UpdateAddress } from '../models';

const addressService = createApi({
  reducerPath: 'addressService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: ['Address'],
  endpoints: (builder) => ({
    createAddress: builder.mutation<Address, NewAddress>({
      query: (body) => ({
        url: '/address',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Address'],
    }),
    updateAddress: builder.mutation<
      Address,
      { addressId: string; data: UpdateAddress }
    >({
      query: ({ addressId, data }) => ({
        url: `/address/${addressId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Address'],
    }),
    getAddressById: builder.query<Address, { addressId: string }>({
      query: ({ addressId }) => ({
        url: `/address/${addressId}`,
        params: {
          include:
            'neighborhood,neighborhood.city,neighborhood.city.stateOrDepartment',
        },
      }),
      providesTags: ['Address'],
    }),
  }),
});

export default addressService;
export const {
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useGetAddressByIdQuery,
} = addressService;
